// Please add new icons here when they are added

/** @deprecated ver1 icon */
const moment_mood_normal = 'moment_mood_normal';
/** @deprecated ver1 icon */
const moment_description_normal = 'moment_description_normal';
/** @deprecated ver1 icon */
const moment_photo_normal = 'moment_photo_normal';
/** @deprecated ver1 icon */
const moment_photo_disabled = 'moment_photo_disabled';
/** @deprecated ver1 icon */
const moment_add = 'moment_add';
/** @deprecated ver1 icon */
const moment_add_disabled = 'moment_add_disabled';
const question_send = 'question_send';
const question_respond = 'question_respond';
/** @deprecated ver1 icon */
const circle_check_checked = 'circle_check_checked';
/** @deprecated ver1 icon */
const circle_check_unchecked = 'circle_check_unchecked';
/** @deprecated ver1 icon */
const heart = 'heart';
/** @deprecated ver1 icon */
const comment = 'comment';
/** @deprecated ver1 icon */
const error = 'error';

// Universal
const notification = 'notification';
const notification_inline = 'notification_inline';
const notification_mute = 'notification_mute';
const hamburger = 'hamburger';
const close = 'close';
const dots_menu = 'dots_menu';
const add_user = 'add_user';
const chat_outline = 'chat_outline';
const edit_outline = 'edit_outline';
const arrow_left = 'arrow_left';
const arrow_right = 'arrow_right';
const search = 'search';
const logo = 'logo';
const like = 'like';
const like_filled = 'like_filled';
const emoji = 'emoji';
const add_emoji = 'add_emoji';
const chevron_up = 'chevron_up';
const chevron_down = 'chevron_down';

// Friends
const hide_true = 'hide_true';
const hide_false = 'hide_false';
const favorite_true = 'favorite_true';
const favorite_false = 'favorite_false';
const expand_open = 'expand_open';
const expand_close = 'expand_close';
const delete_default = 'delete_default';
const friend_updates_profile = 'friend_updates_profile';
const friend_updates_chat = 'friend_updates_chat';
const chat_filled = 'chat_filled';
const edit_filled = 'edit_filled';
const edit_filled_white = 'edit_filled_white';
const share_default = 'share_default';
const copy_default = 'copy_default';
const private_comment_inactive = 'private_comment_inactive';
const private_comment_active = 'private_comment_active';
const private_comment = 'private_comment';

const close_comment = 'close_comment';
const checkbox_rectangle_checked = 'checkbox_rectangle_checked';
const checkbox_rectangle_default = 'checkbox_rectangle_default';
const circle_check = 'circle_check';
const tick = 'tick';

const noti_icon_like = 'noti_icon_like';
const noti_icon_emoji = 'noti_icon_emoji';
const noti_icon_public_comment = 'noti_icon_public_comment';
const noti_icon_private_comment = 'noti_icon_private_comment';
const noti_icon_prompt = 'noti_icon_prompt';
const noti_icon_chat = 'noti_icon_chat';
const add_default = 'add_default';
const star = 'star';
const star_outline = 'star_outline';
const friend_requests = 'friend_requests';
const friend_pinned = 'friend_pinned';
const friend_unpinned = 'friend_unpinned';
const friend_item_chat = 'friend_item_chat';
const group_chat_new = 'group_chat_new';
const close_friend = 'close_friend';
const default_friend = 'default_friend';

// My
const checkbox_default = 'checkbox_default';
const checkbox_checked = 'checkbox_checked';
const spotify = 'spotify';
const default_profile = 'default_profile';
const add_comment = 'add_comment';
const add_note = 'add_note';

// Check In
const availability_available = 'availability_available';
const availability_busy = 'availability_busy';
const availability_might_get_distracted = 'availability_might_get_distracted';
const availability_urgent_only = 'availability_urgent_only';

// Mypage: Bottom Sheet
const add_post = 'add_post';
const home_indicator = 'home_indicator';
const bottomsheet_checkin = 'bottomsheet_checkin';
const bottomsheet_note = 'bottomsheet_note';
const bottomsheet_prompt = 'bottomsheet_prompt';

// Chats
const new_chat = 'new_chat';
const edit_list = 'edit_list';
const camera = 'camera';
const chat_media_image = 'chat_media_image';
const chat_media_gif = 'chat_media_gif';
const green_dot = 'green_dot';
const chat_notification_mute = 'chat_notification_mute';
const search_black = 'search_black';

// Pings
const refresh = 'refresh';
const chat_emoji_add = 'chat_emoji_add';
const favorite_chat = 'favorite_chat';
const chat_send = 'chat_send';

// Note
const delete_image = 'delete_image';

// FIXME: Replace bottom tab icons
const my_profile = 'my_profile';
const friends_active = 'friends_active';
const friends_inactive = 'friends_inactive';
const feed_active = 'feed_active';
const feed_inactive = 'feed_inactive';
const my_active = 'my_active';
const my_inactive = 'my_inactive';
const chats_active = 'chats_active';
const chats_inactive = 'chats_inactive';
const questions_active = 'questions_active';
const questions_inactive = 'questions_inactive';
const discover_active = 'discover_active';
const discover_inactive = 'discover_inactive';
const share_active = 'share_active';
const share_inactive = 'share_inactive';
const update_active = 'update_active';
const update_inactive = 'update_inactive';

const delete_button = 'delete_button';
const top_navigation_friend = 'top_navigation_friend';
const top_navigation_edit = 'top_navigation_edit';
const top_navigation_dots = 'top_navigation_dots';
const top_navigation_chat = 'top_navigation_chat';
const top_navigation_back = 'top_navigation_back';
const edit = 'edit';
const new_add = 'new_add';
const add_battery = 'add_battery';
const add_reaction_default = 'add_reaction_default';
const add_reaction_active = 'add_reaction_active';
const add_reaction = 'add_reaction';

// Notification
const prompts = 'prompts';
const sent_by = 'sent_by';

const comment_reply = 'comment_reply';
const comment_message = 'comment_message';

const hashtag = 'hashtag';
const hashtag_selected = 'hashtag_selected';

const add_playlist = 'add_playlist';
const trash_can = 'trash_can';
const plus = 'plus';
const pin_empty = 'pin_empty';
const pin_filled = 'pin_filled';
const chevron_right = 'chevron_right';
const eye = 'eye';
const view = 'view';
const view_alt = 'view_alt';

export {
  add_battery,
  add_comment,
  add_default,
  add_emoji,
  add_note,
  add_playlist,
  add_post,
  add_reaction,
  add_reaction_active,
  add_reaction_default,
  add_user,
  arrow_left,
  arrow_right,
  availability_available,
  availability_busy,
  availability_might_get_distracted,
  availability_urgent_only,
  bottomsheet_checkin,
  bottomsheet_note,
  bottomsheet_prompt,
  camera,
  chat_filled,
  chat_media_gif,
  chat_media_image,
  chat_notification_mute,
  chat_outline,
  chats_active,
  chats_inactive,
  checkbox_checked,
  checkbox_default,
  checkbox_rectangle_checked,
  checkbox_rectangle_default,
  chevron_down,
  chevron_right,
  chevron_up,
  circle_check,
  circle_check_checked,
  circle_check_unchecked,
  close,
  close_comment,
  close_friend,
  comment,
  comment_message,
  comment_reply,
  copy_default,
  default_friend,
  default_profile,
  delete_button,
  delete_default,
  delete_image,
  discover_active,
  discover_inactive,
  dots_menu,
  edit,
  edit_filled,
  edit_filled_white,
  edit_list,
  edit_outline,
  emoji,
  error,
  eye,
  expand_close,
  expand_open,
  favorite_false,
  favorite_chat,
  favorite_true,
  feed_active,
  feed_inactive,
  friend_item_chat,
  group_chat_new,
  friend_pinned,
  friend_requests,
  friend_unpinned,
  friend_updates_chat,
  friend_updates_profile,
  friends_active,
  friends_inactive,
  green_dot,
  hamburger,
  hashtag,
  hashtag_selected,
  heart,
  hide_false,
  hide_true,
  home_indicator,
  like,
  like_filled,
  logo,
  moment_add,
  moment_add_disabled,
  moment_description_normal,
  moment_mood_normal,
  moment_photo_disabled,
  moment_photo_normal,
  my_active,
  my_inactive,
  my_profile,
  new_add,
  new_chat,
  noti_icon_emoji,
  noti_icon_like,
  noti_icon_chat,
  noti_icon_private_comment,
  noti_icon_prompt,
  noti_icon_public_comment,
  notification,
  notification_inline,
  notification_mute,
  pin_empty,
  pin_filled,
  chat_emoji_add,
  chat_send,
  plus,
  private_comment,
  private_comment_active,
  private_comment_inactive,
  prompts,
  question_respond,
  question_send,
  questions_active,
  questions_inactive,
  refresh,
  search,
  search_black,
  sent_by,
  share_active,
  share_default,
  share_inactive,
  spotify,
  star,
  star_outline,
  tick,
  top_navigation_back,
  top_navigation_chat,
  top_navigation_dots,
  top_navigation_edit,
  top_navigation_friend,
  trash_can,
  update_active,
  update_inactive,
  view,
  view_alt,
};
